import { render } from "./ResolutionAttachmentPart.vue?vue&type=template&id=f6f7744a&scoped=true"
import script from "./ResolutionAttachmentPart.vue?vue&type=script&lang=js"
export * from "./ResolutionAttachmentPart.vue?vue&type=script&lang=js"

import "./ResolutionAttachmentPart.vue?vue&type=style&index=0&id=f6f7744a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f7744a"]])

export default __exports__